import React, { useRef, useEffect, useState } from 'react'
import Logo from '../logo'
import styles from './style.module.scss'

import Input from '../input'

import Button from '../button'

import { useSendResetInstructions } from '../hooks'

import Form from '../form/api-form'

export default () => {
    const formRef = useRef({})
    const { statusCode, submit, loading, response } = useSendResetInstructions({
        formRef
    })
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        if (statusCode === 200) {
            setSuccess(true)
        }
    }, statusCode)

    return (
        <div className={styles.full}>
            <Logo className={styles.logo} />
            <div className={styles.formWrapper}>
                {success ? (
                    <p className={styles.success}>
                        If we found the email address in our records we have
                        sent reset instructions. Follow the link to reset your
                        password.
                    </p>
                ) : (
                    <Form
                        statusCode={statusCode}
                        ref={formRef}
                        loading={loading}
                        response={response}
                        errorsClassName={styles.errors}
                        onSubmit={() => submit()}
                    >
                        <h1 className={styles.title}>Forgot password</h1>

                        <p className={styles.text}>
                            Enter the email address associated with your account
                            and we'll send you a link to reset your password.
                        </p>

                        <Input
                            label={'Email'}
                            name="email"
                            type="email"
                            required
                        />

                        <div className={styles.footer}>
                            <Button className={styles.button}>Continue</Button>
                        </div>
                    </Form>
                )}
            </div>
        </div>
    )
}
